import { AvatarGenerator } from "./AvatarGenerator";

export const animalAvatarGenerator = new AvatarGenerator();
